'use strict';

module.exports = function($state, departments, dialog, Department, templates, $uibModal) {
    var _this = this;
    this.department = departments.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];

    this.templates = templates;

    this.addTemplate = function() {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', 'Department', function($uibModalInstance, Department) {
                var _this = this;
                this.completeForm = null;
                _this.listfields=[];
                _this.newPayload = null;
                if (!this.payload) {
                  this.payload = [];
                }

                this.selectedForm = null;
                if (this.task?.id) {
                  // console.log('this.task', this.task.id, this.task.form)
                    this.selectedForm = this.task.form || null;
                    // console.log("select form", this.selectedForm)    
                    this.listfields = this.selectedForm.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));
                    delete this.task.tenantId;
                }

                this.template = {
                    name: null,
                    description: null,
                    formId: null,
                    payload: this.payload,
                };

                if(!this.payloadhidden)
                    this.payloadhidden = {}

                this.getHiddenStatus = function (index){
                    return _this.payloadhidden[_this.payload[index].key]
                }

                this.addField = function (newValue) {
                    // console.log('newField', newValue)
                    if (!newValue || !newValue.key || !newValue.value) {
                        return;
                    }

                    _this.template.payload.push({
                        key: newValue.key,
                        value: newValue.value,
                        fieldId: newValue.fieldId,
                        id: Math.random().toString(36).substr(2, 9)
                    });

                    // _this.payloadhidden[newValue.key] = false;
                    _this.payloadhidden[newValue.key] = newValue.hidden;

                    _this.newPayload = {
                        key: null,
                        value: null,
                        fieldId:null,
                        hidden: false
                    };
                    // console.log("_this.payload", _this.template.payload)
                    return;
                };

                this.removeValue = function (index) {
                  // console.log("remove", index)
                    _this.payloadhidden[_this.payload[index].key]=undefined;
                    _this.payload.splice(index, 1);
                    return;
                };


                // Anterior
                this.getForms = function(value) {
                  // console.log("getform", value)
                    var query = {
                        id: $state.params.departmentId
                    };

                    if (value) {
                        query.filter = {
                            where: {
                                name: {
                                    regexp: '/^' + value + '/gi'
                                }
                            }
                        };
                    }

                    return Department.forms(query)
                        .$promise
                        .then(function(forms) {
                            return forms;
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                };

                this.formSelected = function(form) {
                  // console.log("formSelected", form)
                    if (form) {
                        this.completeForm = form;
                        _this.template.formId = form.id;
                        _this.listfields = form.pages.flatMap(page => page.fields.filter(f => !["docs", "title", "photo", "video", "sign", "autonumeric", "group"].includes(f.type)));
                        return;
                    }
                    this.completeForm = null;
                    _this.template.formId = null;
                    return;
                };

                this.saveTemplate = function() {
                    // console.log('new return')
                    // console.log('$state.params.departmentId', $state.params.departmentId)
                    // console.log('_this.template', _this.template)
                    // console.log('_this.completeForm', _this.completeForm)

                    return Department.tasktemplate.create({
                            id: $state.params.departmentId
                        }, _this.template)
                        .$promise.then(function(template) {
                            template.form = _this.completeForm;
                            $uibModalInstance.close(template);
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                };

            }],
            templateUrl: 'dashboard-tasks-templates/newTemplateModal.html',
            controllerAs: 'modal',
            size: 'lg',
            windowClass: 'dialog',
            bindToController: true
        }).result.then(function(template) {
            _this.templates.push(template);
        });
    };
};
